export const APP_NAME = "lpg-offers";
export const apiEndpoints = {
  lpgPlans: "/lpg/offers/api/v1",
};

export enum Routes {
  INDEX = "/",
  REQUEST_CALLBACK = "/callback",
  THANK_YOU = "/thank-you",
}

export const CUSTOMISATION_PATH = "/customisation";
export const LPG_SERVICES_CUSTOMISATION_PATH = `${CUSTOMISATION_PATH}/lpg-services`;

export const OFFERS_MIN_HEIGHT = "480px";

export const MINIMUM_LOADING_TIME = TAL.config.minimumLoadingTime;

// Timeout (ms) for the primary SAP address call before falling back to asyncMeterResolution
export const SAP_ADDRESS_TIMEOUT_MS = 5000;
